// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7ff150c1","787":"e592cfa3"}[chunkId] + ".chunk.js";
};